import React from 'react'
import { intl } from 'lang/intl'

import { TtButton, TtIcon, TtTooltip } from '@23/ui-react'

import { switchToTray, useFloorState } from '../../../firebase/hooks/useFloor'
import { useLastActiveMediaTrayCard } from '../../../firebase/hooks/useTray'

import './TrayFloorTrigger.scss'

interface TrayFloorTriggerProps {
  disabled: boolean
}

const TrayFloorTrigger = ({ disabled }: TrayFloorTriggerProps) => {
  const floorState = useFloorState()
  const lastActiveMediaTrayCard = useLastActiveMediaTrayCard()

  if (!lastActiveMediaTrayCard) return null

  const active = floorState?.layout === 'tray'

  return (
    <TtTooltip
      placement="bottom"
      content={intl.formatMessage({
        defaultMessage: 'Show WebinarTray Fullscreen',
      })}
      hoist
    >
      <TtButton
        className="tray-floor-trigger"
        data-active={active}
        color="secondary"
        size="x-small"
        // @ts-expect-error — inert is a valid html attribute; React is too old to recognize it
        inert={disabled ? 'true' : undefined}
        variant="default"
        onClick={switchToTray}
      >
        <TtIcon
          library="one/webinars"
          name={active ? 'tray-mix-on' : 'tray-mix-off'}
        />
      </TtButton>
    </TtTooltip>
  )
}

export { TrayFloorTrigger }
